// lib
import React, { memo } from 'react';

// styles
import { Container, Title, LinkContainer, Link, DownloadImage } from './styles';

//types
import { AppDataProps } from './types';

function DownloadApp({ text, sections }: AppDataProps) {
  return (
    <Container>
      <Title>{text}</Title>
      <LinkContainer>
        {!!sections.length &&
          sections
            .filter((icon) => icon.isEnabled)
            .map((data, index) => {
              return (
                <Link aria-label={data.title} key={`download-app-${data.title || index}`} href={data.action_url}>
                  <DownloadImage aria-hidden src={data.image_url} alt={data.title} />
                </Link>
              );
            })}
      </LinkContainer>
    </Container>
  );
}

export default memo(DownloadApp);
